import { createSlice } from "@reduxjs/toolkit";
import { CampaignPerformanceSlice } from "types/campaign/performance";
import { fetchCampaignPerformance } from "./thunk";

const initialState: CampaignPerformanceSlice  = {
    loading: false,
    error: null,
    campaigns: {},
    default_date_range: null
}

const campaignPerformanceSlice = createSlice({
    name: 'campaignPerformance',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchCampaignPerformance.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchCampaignPerformance.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.error = null;

            const {campaignId, campaignPerformance, isDefault} = payload;

            const existingData = state.campaigns[campaignId] ?? {};

            const dateRange = `${campaignPerformance.campaign.generate_insights_from}-${campaignPerformance.campaign.generate_insights_till}`;

            state.campaigns[campaignId] = {
                ...existingData,
                [dateRange]: {
                    performance: campaignPerformance,
                    last_fetched_at: Date.now(),
                    expired: false,
                }
            };

            if(isDefault)
                state.default_date_range = dateRange;

        })
        .addCase(fetchCampaignPerformance.rejected, (state, {payload}) => {
            state.loading = false;
            state.error = payload ?? 'Failed to fetch campaign performance data!';
        })

    }
})

export default campaignPerformanceSlice.reducer;
